/**
 * Created by Ning Jiang on 10/10/2018.
 */


import { Power1, Timeline, TimelineLite, TweenLite, TimelineMax } from "gsap";
import { PunkCounter } from "../../../independent/countup/PunkCounter";
import { Point } from "pixi.js";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../../PunkGameConfig";
import { PunkEngineManager } from "../../../../punkEngine/PunkEngineManager";

export class BigWinCountUp extends PunkCounter {

    private moved:boolean = false;

    constructor() {
        super({
            font : {
                name : "NumbersWinCountUp",
                size : 48
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16),
        });
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this);
        this.zIndex = 1;
    }

    public disableCounter():void {
        this._countUp.alpha = 0;
        this._countUp.showValue(0);
    }

    public getCountUpAnimation(from:number, to:number, duration:number):Timeline {
        const timeline:TimelineMax = new TimelineMax();
        const maxWitdth:number = PunkEngineManager.ReelAreaWidth;
        this.moved = false;
        timeline.add([
            () => {
                this.position.y = 540;
                this._countUp.maxTextWidth = maxWitdth/1.35;
                this._countUp.alpha = 1;
            },
            this._countUp.getCountUpAnimation(from, to, {duration : duration, ease : Power1.easeInOut})
        ]);
        return timeline;
    }

    public moveUp():void{
        this.moved = true;
        TweenLite.to(this.position, .5, {y: 360});
    }

    public abort(endValue:number):void {
        super.abort(endValue);
    }

    public getAbortAnimation(endValue:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        return timeline;
    }
    
    public onResize(xOffset:number = 0):void{
        if(this.moved){
            this.position = new Point(360+xOffset,360);
        }else
            this.position = new Point(360+xOffset,540);
    }
}